import {useSnackbar} from "notistack";
const useMessageNotifier = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const showMessage = (message, variant, persist = false, autoHideDuration = 5000, position = { vertical: 'top', horizontal: 'right' }) => {
        let backgroundColor;
        let textColor;

        switch (variant) {
            case 'success':
                backgroundColor = '#48BECD';
                textColor = '#455A64';
                break;
            case 'error':
                backgroundColor = '#EF595D';
                textColor = '#ffffff';
                break;
            case 'info':
                backgroundColor = '#2196f3';
                textColor = '#ffffff';
                break;
            case 'warning':
                backgroundColor = '#ff9800';
                textColor = '#ffffff';
                break;
            default:
                backgroundColor = '#1976d2';
                textColor = '#ffffff';
        }

        enqueueSnackbar(message, {
            variant: variant,
            autoHideDuration: autoHideDuration,
            persist: persist,
            anchorOrigin: position,
            ContentProps: {
                style: {
                    backgroundColor: backgroundColor,
                    color: textColor,
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '14px',
                },
            },
        });
    };

    return { showMessage };
};

export default useMessageNotifier;
